// import Bills from "../../all-patient/layouts/Bills";
import Certificates from "../../all-patient/layouts/Certificates";
import LabTest from "../../all-patient/layouts/LabTest";
import Prescriptions from "../../all-patient/layouts/Prescriptions";
import Appointments from "../../all-patient/pages/Appointments";
import { getImageURLwithouttoken } from "../utils/image";
const getBaseAndToken = () => {
  const hostname = window.location.hostname;

  const config = {
    localhost: {
      WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL,
      BASE_URL: process.env.REACT_APP_BASE_URL,
      ADMIN_TOKEN: process.env.REACT_APP_AUTH_TOKEN,
      PATIENT_ROLE: process.env.REACT_APP_PATIENT_ROLE,
      QUREAL_BASE_URL: process.env.REACT_APP_QUREAL_BASE_URL,
    },
    "dev.cufront.com": {
      BASE_URL: process.env.REACT_APP_BASE_URL,
      ADMIN_TOKEN: process.env.REACT_APP_AUTH_TOKEN,
      PATIENT_ROLE: process.env.REACT_APP_PATIENT_ROLE,
      QUREAL_BASE_URL: process.env.REACT_APP_QUREAL_BASE_URL,
    },

    default: {
      WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL,
      BASE_URL: process.env.REACT_APP_BASE_URL,
      ADMIN_TOKEN: process.env.REACT_APP_AUTH_TOKEN,
      PATIENT_ROLE: process.env.REACT_APP_PATIENT_ROLE,
      QUREAL_BASE_URL: process.env.REACT_APP_QUREAL_BASE_URL,
    },
  };

  const {
    BASE_URL,
    ADMIN_TOKEN,
    PATIENT_ROLE,
    WEBSOCKET_URL,
    QUREAL_BASE_URL,
  } = config[hostname] || config["default"];

  return {
    BASE_URL,
    ADMIN_TOKEN,
    PATIENT_ROLE,
    WEBSOCKET_URL,
    QUREAL_BASE_URL,
  };
};

const { BASE_URL, ADMIN_TOKEN, PATIENT_ROLE, WEBSOCKET_URL, QUREAL_BASE_URL } =
  getBaseAndToken();

export const IMAGE_BASE_URL = `https://cufrontdata.s3.amazonaws.com`;

export { BASE_URL, ADMIN_TOKEN, PATIENT_ROLE, WEBSOCKET_URL, QUREAL_BASE_URL };

export const FRAME_24 =
  BASE_URL === `https://testapi.bharathealpoint.com/`
    ? getImageURLwithouttoken("92aad9a6-410e-4ef8-b9e2-8adf379d9280")
    : getImageURLwithouttoken("2e0bcebe-37ea-4205-ae99-86b58be58141");

export const PHONE_FRAME =
  BASE_URL === `https://testapi.bharathealpoint.com/`
    ? getImageURLwithouttoken("eb15d34f-e745-4dd9-9f19-2689d2076c01")
    : getImageURLwithouttoken("bb6c1414-b5b6-47a1-b4df-5bf09b51743d");

export const MORNING_TIME = {
  START_TIME: "09:00",
  END_TIME: "17:00",
};

export const EVENING_TIME = {
  START_TIME: "18:00",
  END_TIME: "23:00",
};

export const medicalTabs = [
  // { name: "All", label: "All", component: <AllRecords /> },
  {
    name: "Appointments",
    label: "Appointments",
    component: <Appointments />,
  },
  {
    name: "Prescriptions",
    label: "Prescriptions",
    component: <Prescriptions />,
  },
  {
    name: "Certificates",
    label: "Certificates",
    component: <Certificates />,
  },
  { name: "Lab_Reports", label: "Lab Tests", component: <LabTest /> },
];

export const record_type = [
  {
    id: 1,
    type: "Prescriptions",
  },

  // {
  //   id: 2,
  //   type: "Bills",
  // },

  {
    id: 3,
    type: "Certificates",
  },

  {
    id: 4,
    type: "Lab Reports",
  },
];

export function calculateAge(dob) {
  var currentDate = new Date();
  var birthDate = new Date(dob);

  var age = currentDate.getFullYear() - birthDate.getFullYear();

  var monthDiff = currentDate.getMonth() - birthDate.getMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
}

export const QUREAL_TOKEN = process.env.REACT_APP_QUREAL_TOKEN;
export const THEME_CLR = process.env.REACT_APP_THEME_CLR;
export const DARK_GREY = process.env.REACT_APP_DARKGREY_CLR;
export const LIGHT_GREY = process.env.REACT_APP_LIGHTGREY_CLR;
export const BLACK = process.env.REACT_APP_BLACK_CLR;
export const LIGHT_GREEN = process.env.REACT_APP_LIGHTGREEN_CLR;
